module.exports = __webpack_public_path__ + "media/images/thieme-synaptiq-logo-dark-78ab7991.svg";